module.exports = __webpack_public_path__ + "img/gas.db432046.svg";